function LoginRegisterModule (registerType, invitationCode) {
  var self = this
  self.registerType = ko.observable('user')
  self.invitationCode = ko.observable('')
  self.facebookModule = new FacebookModule()
  self.googleModule = new GoogleModule()
  self.appleModule = new AppleModule()

  self.redirectUrl = ko.observable((typeof TROVACIGUSTO !== 'undefined') ? TROVACIGUSTO.redirectUrl : null)

  self.catering = ko.observable(null)
  self.user = ko.observable(null)
  self.password = ko.observable(null)
  self.password_confirmation = ko.observable(null)
  self.loading = ko.observable(false)
  self.responseMessageSuccess = ko.observable('')
  self.responseMessageError = ko.observable('')
  self.passwordMessageError = ko.observable('')
  self.acceptedPrivacy = ko.observable(false)
  self.email = ko.observable(null)

  self.showPassword = ko.observable(false)
  self.senderInviteType = ko.observable('catering')
  self.modeInvite = ko.observable(false)
  self.inputRegisterLabel = ko.observable('Inserisci la tua email')

  /**
   * Remote logging helper for Facebook login debugging.
   * 
   * IMPORTANTE: Questa funzione invia log al server per debug del login Facebook/GoNative.
   * E stata usata per risolvere il problema del login Facebook su iOS (Dicembre 2025).
   * 
   * Per riabilitare il logging, decommentare il corpo della funzione.
   * I log vengono salvati in: app/storage/logs/YYYY-MM-DD/facebook.log
   * Endpoint: POST /api/v2/facebook/jslog
   * 
   * @param {string} message - Identificatore del punto di log (es. "FACEBOOK_SIGNIN_START")
   * @param {object} data - Dati da loggare (verranno serializzati in modo sicuro)
   */
  self.remoteLog = function(message, data) {
    // LOGGING DISABILITATO - Decommentare per debug
    // console.log("[LRM DEBUG]", message, data);
    return;
    
    /* === INIZIO CODICE LOGGING (commentato) ===
    try {
      var safeData = {};
      if (data && typeof data === "object") {
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            try {
              var val = data[key];
              if (val === null || val === undefined) {
                safeData[key] = val;
              } else if (typeof val === "function") {
                safeData[key] = "[function]";
              } else if (typeof val === "object") {
                try {
                  JSON.stringify(val);
                  safeData[key] = val;
                } catch(e) {
                  safeData[key] = "[unserializable]";
                }
              } else {
                safeData[key] = val;
              }
            } catch(e) {
              safeData[key] = "[error]";
            }
          }
        }
      } else {
        safeData = data;
      }
      
      fetch("/api/v2/facebook/jslog", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          message: "LRM_" + message,
          data: safeData,
          timestamp: new Date().toISOString()
        })
      }).catch(function(e) {});
    } catch(e) {}
    === FINE CODICE LOGGING === */
  }

  self.email.extend({required: true, email: true})
  self.password.extend({required: true})
  self.password_confirmation.extend({required: true})

  self.register = function () {
    var message = ''
    self.basicRegister()
        .then(function (response) {
          if (response.success && response.data.redirect)
            window.location.href = response.data.redirect;
          if (response.success) {
            self.onesignalGetData()
            if (self.registerType() !== 'catering' && self.registerType() !== 'supplier') {
              message = "Ok! Ora Completa e Invia la Richiesta, poi segui le istruzioni dopo l'invio"
              self.responseMessageSuccess(message)
              pNotify(message)
            }
          }
        })
        .catch(function (response) {
          self.loading(false)
        })
  }

  self.login = function () {
    self.basicLogin()
        .then(function (response) {
          if (response.success) {
            pNotify('Login riuscito')
            self.onesignalGetData()
            if (response.data.url)
              location.href = response.data.url
            else
              location.reload()
          } else {
            self.responseMessageError('Login non riuscito. ' + response.message)
            pNotify('Login non riuscito. ' + response.message, 'error')
          }
        })
  }

  self.basicRegister = function () {
    var message = ''
    var data = {
      email: self.email(),
      type: self.registerType(),
      invitationCode: self.invitationCode(),
      senderType: self.senderInviteType(),
      cateringId: self.catering() ? ko.unwrap(self.catering().id) : '',
      userId: self.user() ? ko.unwrap(self.user().id) : '',
      acceptedPrivacy: self.acceptedPrivacy()
    }

    if (!self.email()) {
      self.responseMessageError('Inserisci un indirizzo email')
      pNotify('Inserisci un indirizzo email', 'warning')
      return Promise.reject()
    }
    if (!self.checkPolicy())
      return Promise.reject()
    self.responseMessageSuccess('')
    self.responseMessageError('')

    var url = '/api/v2/register'
    if (self.modeInvite())
      url = '/api/v2/invite/register'

    self.loading(true)
    return rest('POST', url, data)
        .then(function (response) {
          if (response.success) {
            self.onesignalGetData()
          } else {
            message = "L'iscrizione non e riuscita, email non corretta o gia in uso. Se hai dimenticato la password, vai alla schermata di accesso e segui l'apposita procedura per recuperarla."
            trovacigusto.modalLogin.loginRegisterModule.responseMessageError(message)
            pNotify(message, 'error', null, null, false)
          }
          self.modeInvite = ko.observable(false)
          self.loading(false)
          return response
        })
  }

  self.basicLogin = function () {
    if (!(self.password() && self.email())) {
      self.responseMessageError('Inserisci il tuo indirizzo email e la tua password')
      pNotify('Inserisci il tuo indirizzo email e la tua password', 'warning')
      return Promise.reject()
    }
    self.responseMessageSuccess('')
    self.responseMessageError('')
    var data = {
      password: self.password(),
      email: self.email(),
      redirectUrl: self.redirectUrl()
    }
    self.loading(true)
    return rest('POST', '/api/v2/login', data)
        .then(function (response) {
          if (response.success && self.modeInvite()) {
            trovacigusto.flagVM.store('catering', self.catering() ? ko.unwrap(self.catering().id) : '')
          }
          self.loading(false)
          return response
        })
        .fail(function (response) {
          self.loading(false)
          return response
        })

  }


  self.onesignalGetData = function () {
    if (navigator.userAgent.indexOf('gonative') >= 0) {
      gonative.onesignal.onesignalInfo().then(function (oneSignalInfo) {
        rest('POST', '/api/v2/users/onesignal', oneSignalInfo)
      })
    }
  }

  self.getRedirectCallback = function (forceRedirectUrl) {
    return function (redirectUrl) {
      self.remoteLog('REDIRECT_CALLBACK_CALLED', {redirectUrl: redirectUrl, forceRedirectUrl: forceRedirectUrl});
      if (redirectUrl) {
        var url = new URL(forceRedirectUrl && typeof forceRedirectUrl === 'string' ? forceRedirectUrl : redirectUrl, getBaseURL())
        url.searchParams.set('logged', Math.random().toString(36))
        self.remoteLog('REDIRECTING_TO', {url: url.href});
        location.href = url.href
      }
    };
  }

  self.facebookSignin = function (forceRedirectUrl) {
    self.remoteLog('FACEBOOK_SIGNIN_START', {
      userAgent: navigator.userAgent,
      isGonative: navigator.userAgent.indexOf('gonative') >= 0,
      forceRedirectUrl: forceRedirectUrl
    });
    
    self.facebookModule.registerType(self.registerType())
    self.facebookModule.invitationCode(self.invitationCode())
    self.facebookModule.redirectCallback = self.getRedirectCallback(forceRedirectUrl)
    
    if (navigator.userAgent.indexOf('gonative') >= 0) {
      self.remoteLog('GONATIVE_FB_STEP1_CHECK_OBJECTS', {
        hasWindow: typeof window !== 'undefined',
        hasGonative: typeof window.gonative !== 'undefined',
        gonativeKeys: typeof window.gonative !== 'undefined' ? Object.keys(window.gonative) : [],
        hasSocialLogin: typeof window.gonative !== 'undefined' && typeof window.gonative.socialLogin !== 'undefined',
        socialLoginKeys: typeof window.gonative !== 'undefined' && typeof window.gonative.socialLogin !== 'undefined' ? Object.keys(window.gonative.socialLogin) : [],
        hasFacebook: typeof window.gonative !== 'undefined' && typeof window.gonative.socialLogin !== 'undefined' && typeof window.gonative.socialLogin.facebook !== 'undefined',
        facebookKeys: typeof window.gonative !== 'undefined' && typeof window.gonative.socialLogin !== 'undefined' && typeof window.gonative.socialLogin.facebook !== 'undefined' ? Object.keys(window.gonative.socialLogin.facebook) : []
      });
      
      // Store reference to self for callback
      var moduleRef = self;
      
      try {
        self.remoteLog('GONATIVE_FB_STEP2_CALLING_LOGIN', {});
        
        window.gonative.socialLogin.facebook.login({
          callback: function (response) {
            moduleRef.remoteLog('GONATIVE_FB_STEP3_CALLBACK_ENTRY', {
              callbackFired: true,
              hasResponse: typeof response !== 'undefined',
              responseIsNull: response === null,
              responseType: typeof response
            });
            
            try {
              moduleRef.remoteLog('GONATIVE_FB_STEP4_RESPONSE_DETAILS', {
                response: response,
                responseStringified: JSON.stringify(response)
              });
              
              if (response) {
                moduleRef.remoteLog('GONATIVE_FB_STEP5_CALLING_FB_MODULE', {
                  responseKeys: Object.keys(response),
                  status: response.status,
                  type: response.type,
                  limitedLogin: response.limitedLogin,
                  hasAuthToken: !!response.authToken,
                  hasAccessToken: !!response.accessToken,
                  userId: response.userId
                });
              }
              
              moduleRef.facebookModule.facebookLoginCallback(response);
              
              moduleRef.remoteLog('GONATIVE_FB_STEP6_FB_MODULE_RETURNED', {});
            } catch (innerError) {
              moduleRef.remoteLog('GONATIVE_FB_CALLBACK_INNER_ERROR', {
                error: innerError.toString(),
                stack: innerError.stack,
                message: innerError.message
              });
            }
          },
          scope: 'public_profile, email',
          // Su iOS sempre il login limitato: risponde con authToken, un JWT firmato che il server
          // verifica. Senza consenso al tracciamento l'SDK iOS lo userebbe comunque, ma l'app non
          // sempre lo segnala e manda un accessToken non leggibile, che il server rifiuta
          forceLimitedLogin: /GoNativeIOS|iPhone|iPad|iPod/i.test(navigator.userAgent)
        });
        
        self.remoteLog('GONATIVE_FB_STEP2B_LOGIN_CALLED_SUCCESS', {});
      } catch(e) {
        self.remoteLog('GONATIVE_FB_LOGIN_OUTER_ERROR', {
          error: e.toString(),
          stack: e.stack,
          message: e.message
        });
      }
    } else {
      self.remoteLog('WEB_FB_CHECKSTATUS', {});
      self.facebookModule.checkStatus()
    }
  }

  self.facebookSignup = function (forceRedirectUrl) {
    self.remoteLog('FACEBOOK_SIGNUP_CALLED', {forceRedirectUrl: forceRedirectUrl, policyAccepted: self.acceptedPrivacy()});
    if (self.checkPolicy()) {
      self.facebookSignin(forceRedirectUrl)
    }
  }

  self.googleSignin = function (forceRedirectUrl) {
    self.googleModule.registerType(self.registerType())
    self.googleModule.invitationCode(self.invitationCode())
    self.googleModule.redirectCallback = self.getRedirectCallback(forceRedirectUrl)

    if (navigator.userAgent.indexOf('gonative') >= 0) {
      window.gonative.socialLogin.google.login({
        'callback': function (response) {
          self.googleModule.googleLoginCallback(response)
        }
      })
    } else {
      self.googleModule.login()
    }
  }

  self.googleSignup = function (forceRedirectUrl) {
    if (self.checkPolicy()) {
      self.googleSignin(forceRedirectUrl)
    }
  }

  self.appleSignin = function (forceRedirectUrl) {
    self.appleModule.registerType(self.registerType())
    self.appleModule.invitationCode(self.invitationCode())
    self.appleModule.redirectCallback = self.getRedirectCallback(forceRedirectUrl);
    if (navigator.userAgent.indexOf('gonative') >= 0) {
      window.gonative.socialLogin.apple.login({
        'callback': function (response) {
          self.appleModule.signIn(response)
        },
        'scope': 'full_name, email'
      })

    } else {
      self.appleModule.login()
    }
  }

  self.appleSignup = function (forceRedirectUrl) {
    if (self.checkPolicy()) {
      self.appleSignin(forceRedirectUrl)
    }
  }

  self.checkPolicy = function () {
    if (!self.acceptedPrivacy()) {
      self.responseMessageError('Devi accettare Privacy Policy e Terms & Conditions')
      pNotify('Devi accettare Privacy Policy e Terms & Conditions', 'warning')
      return false
    }
    return true
  }

  var togglePassword = document.querySelector('#togglePassword');
  var toggleConfirmPassword = document.querySelector('#toggleConfirmPassword');
  var password = document.querySelector('#password');
  var confirmPassword = document.querySelector('#confirmPassword');

  if (togglePassword && password) {
    togglePassword.addEventListener('click', function (e) {
      var type = password.getAttribute('type') === 'password' ? 'text' : 'password';
      password.setAttribute('type', type);
      this.classList.toggle('fa-eye-slash');
    });
  }

  if (toggleConfirmPassword && confirmPassword) {
    toggleConfirmPassword.addEventListener('click', function (e) {
      var type = confirmPassword.getAttribute('type') === 'password' ? 'text' : 'password';
      confirmPassword.setAttribute('type', type);
      this.classList.toggle('fa-eye-slash');
    });
  }

  self.checkConfirmPassword = function () {
    self.passwordMessageError('')
    if (!self.password() || !self.password_confirmation())
      return false
    if (self.password() !== self.password_confirmation()) {
      self.passwordMessageError('Le password non coincidono')
      return false
    }
    return true
  }

  self.checkPasswordRules = function () {
    self.passwordMessageError('')
    if (self.password() && self.password().length < 6) {
      self.passwordMessageError('La password deve essere lunga almeno 6 caratteri')
      return false
    }
    if (self.password() && !self.password().match(/[a-z]/)) {
      self.passwordMessageError('La password deve contenere almeno una lettera minuscola')
      return false
    }
    if (self.password() && !self.password().match(/[A-Z]/)) {
      self.passwordMessageError('La password deve contenere almeno una lettera maiuscola')
      return false
    }
    if (self.password() && !self.password().match(/[0-9]/)) {
      self.passwordMessageError('La password deve contenere almeno un numero')
      return false
    }
    return self.checkConfirmPassword() !== false;

  }

  self.setInvite = function (registerType, invitationCode) {
    if (registerType) {
      self.registerType(registerType)
      self.inputRegisterLabel(self.registerType() === 'catering' ? "Inserisci l'email della tua Attivita" : 'Inserisci la tua email')

    }
    if (invitationCode)
      self.invitationCode(invitationCode)
  }

  self.setInvite(registerType, invitationCode)

  self.checkIsGonative = function () {
    if (navigator.userAgent.indexOf('gonative') > -1) {
      $('.mobileNav').hide()
      $('.appOnly').show()
    }
    if (navigator.userAgent.indexOf('GoNativeAndroid/1.0 gonative') > -1) {
      $('.appAndroidOnly').show()
      $('.appIosOnly').hide()
    }
    if (navigator.userAgent.indexOf('GoNativeIOS/1.0 gonative') > -1) {
      $('.appIosOnly').show()
      $('.appAndroidOnly').hide()

    }
  }

  self.checkIsGonative()

  /**
   * Pre-carica gli SDK dei login social (tutti, o solo `provider`). Si chiama solo quando
   * l'utente chiede di accedere: modale di login o registrazione aperto, pagine /login e
   * /register (public/js/vm/page-register-login.js), casella privacy di un modulo di
   * iscrizione spuntata, tasto del mouse premuto su un elemento con data-social-login.
   * Serve ai popup di Apple e Facebook: con l'SDK gia' pronto il click li apre in modo
   * sincrono e il browser non li blocca.
   * Gli errori qui si ignorano: se lo script non arriva, lo segnalera' il click.
   */
  self.preloadSocialSdks = function (provider) {
    // Nell'app i login social passano dal bridge nativo di GoNative.
    if (navigator.userAgent.indexOf('gonative') >= 0) {
      return
    }
    var modules = {
      google: self.googleModule,
      apple: self.appleModule,
      facebook: self.facebookModule
    }
    Object.keys(modules).forEach(function (name) {
      if (!provider || provider === name) {
        modules[name].loadSdk().catch(function () {})
      }
    })
  }

  // Fuori dal modale e dalle pagine di accesso (iscrizione delle home verticali, carrello,
  // moduli di iscrizione nelle pagine) spuntare la casella privacy e' gia' il passo verso
  // l'iscrizione: con gli SDK pronti, il primo tocco su Facebook o Apple apre il popup
  // anche su Safari, che lo blocca se arriva dopo un caricamento. Dove la casella non c'e'
  // resta il caricamento al click. loadSdk riusa la stessa promessa: spuntarla di nuovo
  // non ricarica niente.
  self.acceptedPrivacy.subscribe(function (accepted) {
    if (accepted) {
      self.preloadSocialSdks()
    }
  })

  // Un solo ascoltatore delegato per pagina (le istanze del modulo sono piu' d'una):
  // vale anche per i pulsanti che Knockout inserisce dopo, nei modali e nei template.
  // Conta solo il tasto del mouse premuto sul pulsante, che e' gia' la richiesta di
  // accedere e anticipa di un attimo il click. Non il passaggio del mouse ne' il focus,
  // e nemmeno il dito: sul telefono pointerdown arriva anche quando si comincia a
  // scorrere la pagina. Da tastiera e al tocco lo script parte al click, dal pulsante.
  if (!window.tgSocialLoginIntent) {
    window.tgSocialLoginIntent = true
    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) {
        return
      }
      var target = event.target
      var button = target && typeof target.closest === 'function' ? target.closest('[data-social-login]') : null
      if (button) {
        self.preloadSocialSdks(button.getAttribute('data-social-login'))
      }
    }, { capture: true, passive: true })
  }

  return self
}

/**
 * Esegue openFn, che apre il popup di un login social, e dice se il browser l'ha
 * bloccato: succede quando la chiamata non parte in modo sincrono dal click (per esempio
 * perche' l'SDK ha finito di caricarsi dopo), e allora window.open restituisce null.
 * window.open e' intercettata solo per la durata della chiamata.
 * Usata da facebookModule.js e appleModule.js, che esistono solo dentro LoginRegisterModule.
 */
function socialLoginPopupBlocked (openFn) {
  var originalOpen = window.open
  var blocked = false
  window.open = function () {
    var popup = originalOpen.apply(window, arguments)
    if (!popup) {
      blocked = true
    }
    return popup
  }
  try {
    openFn()
  } finally {
    window.open = originalOpen
  }
  return blocked
}

